// extracted by mini-css-extract-plugin
export default {"container":"Header_container__UnYBB","title":"Header_title__UpCDj","header":"Header_header__ZpK8e","arrow":"Header_arrow__eKFWa","desc":"Header_desc__5LObm"};